// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220505/js/" + chunkId + "." + {"44":"efedf1a8","225":"48f5ae58","481":"94e30400","486":"c0e6912b","770":"6ff99a98"}[chunkId] + ".0.7300131228106379.chunk.js";
};